import axios from 'axios';
import { from } from 'rxjs';

export const voidSingleLabel = (fulfillmentId, shouldReconcileShipTo = false) => {
  const post = axios
    .post('label/void', {
      fulfillmentIds: [fulfillmentId],
      shouldReconcileShipTo,
    })
    .then((response) => {
      return response.data;
    });

  const voidedLabels$ = from(post);
  return voidedLabels$;
};
